import { request } from "../utils";
import { message } from "antd";

export function getAreaAPI(){
    return request({
        url:'/admin/area/list',
        method:'GET'
    })
}
export function getAreaListAPI(params){
    return request({
        url:'/admin/area/page',
        method:'GET',
        params:params
    })
}
export function addAreaAPI(data){
    return request({
        url:'/admin/area/add',
        method:'POST',
        data:data
    }).then((res) => {
        console.log(res.data.message);
        message.success("添加成功");
        return res.data
      })
      .catch((err) => {
        console.log(err.message)
        message.error("添加失败");
      });
}
export function updataAreaAPI(data){
    return request({
        url:'/admin/area/update',
        method:'PUT',
        data:data
    }).then((res) => {
        console.log(res.data.message);
        message.success("修改成功");
        return res.data
      })
      .catch((err) => {
        console.log(err.message)
        message.error("修改失败");
      });
}
export function deleteAreaAPI(areaId){
    return request({
        url:`/admin/area/delete/${areaId}`,
        method:'DELETE'
    }).then((res) => {
        console.log(res.data.message);
        message.success("删除成功");
        return res.data
      })
      .catch((err) => {
        console.log(err.message)
        message.error("删除失败");
      });
}
export function batchDeleteAreaAPI(data){
    return request({
        url:'/admin/area/delete/batch',
        method:'DELETE',
        data:data
    }).then((res) => {
        console.log(res.data.message);
        message.success("批量删除成功");
        return res.data
      })
      .catch((err) => {
        console.log(err.message)
        message.error("批量删除失败");
      });
}